/**
 * Created by Claude on 30.01.2026
 */

class LightningRushWindowController extends ScriptComponent {
    onCreate() {
        this.bus = new cleverapps.EventEmitter();

        this.mission = this.options.mission;
        this.closeWindowCallback = this.options.closeWindowCallback;

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    }

    getMission() {
        return this.mission;
    }

    getType() {
        return this.mission.type;
    }

    getName() {
        return this.mission.getName();
    }

    getTable() {
        return this.mission.runningCompetition.table;
    }

    getPrize() {
        return this.mission.getPrize();
    }

    isRunning() {
        return this.mission.isRunning();
    }

    isPrizeState() {
        return this.mission.logic.isPrizeState();
    }

    getTimeLeft() {
        return this.mission.logic.competitionTimeLeft();
    }

    onShow() {
        this.mission.runningCompetition.table.showUp();

        this.bus.trigger("show");
    }

    onHide() {
        this.bus.trigger("hide");
    }

    onClose() {
        this.mission.logic.receivePrize();

        if (this.mission.runningCompetition) {
            this.mission.runningCompetition.updateShownPlace();
        }

        this.mission.updateMissionIcon();
    }

    getContentType() {
        if (cleverapps.config.type === "merge2") {
            return "garden";
        }
        return "standard";
    }
}
